<script setup lang="ts">
import { ref, toRefs } from 'vue';
import Dialog from 'primevue/dialog';
import { useRelayHubStore } from '@/store';
import { EMIT } from '@/enum';
import { TreeNode } from 'primevue/treenode';

interface Props {
  organization: TreeNode;
}
const props = defineProps<Props>();
const { organization } = toRefs(props);

const relayHubStore = useRelayHubStore();

const selectedItem = ref();
const district_medicaid_code = ref<string>(organization.value.medicaid_district_code || '');

const emit = defineEmits<{
  (e: EMIT.CANCEL): void;
  (e: EMIT.SAVE): void;
}>();

const modalVisible = ref(true);

const save = async () => {
  organization.value.medicaid_district_code = district_medicaid_code.value;
  await relayHubStore.updateOrganizationDistrictCode(district_medicaid_code.value, organization.value.id);

  if (relayHubStore.error) relayHubStore.doToast(relayHubStore.error as string, 'Error', true);
  else relayHubStore.doToast('Organization Updated');

  emit(EMIT.SAVE);
};

const cancel = () => {
  selectedItem.value = null;
  emit(EMIT.CANCEL);
};
</script>

<template>
  <Dialog v-model:visible="modalVisible" class="dialog__container" :modal="true" :draggable="false" @hide="cancel">
    <template #header>
      <div class="dialog__header flex flex-column w-8">
        <h2 class="mb-3">Edit {{ organization.name }}</h2>
      </div>
    </template>
    <div class="flex flex-column">
      <div class="w-full my-3 flex flex-column gap-1">
        <label class="required" for="dmc">District Medicaid Code</label>
        <InputText id="dmc" v-model="district_medicaid_code" class="w-full" />
      </div>
    </div>
    <template #footer>
      <AppButton type="secondary" text="Cancel" @click="cancel" />
      <AppButton type="primary" text="Save" :disabled="!district_medicaid_code" @click="save" />
    </template>
  </Dialog>
</template>
